export default "__VITE_ASSET__CNHdNzaN__"